import Vue from 'vue'
import Router from 'vue-router'
import Event from '@/pages/events/index.vue'
import Ranking from '@/pages/ranking/index.vue'
import Download from '@/pages/download/index.vue'
import NotFound from '@/pages/notfound/index.vue'
import Login from '@/pages/login/index.vue'
import LoginSuccess from '@/pages/login/success/index.vue'
import LoginError from '@/pages/login/error/index.vue'
import Logout from '@/pages/logout/index.vue'
import MyPage from '@/pages/mypage/index.vue'
import PaymentRegistration from '@/pages/mypage/payment_registration/index.vue'
import Personal from '@/pages/mypage/payment_registration/personal/index.vue'
import PaymentHistories from '@/pages/mypage/payment_histories/index.vue'
import Bank from '@/pages/mypage/payment_registration/bank/index.vue'
import Gift from '@/pages/mypage/payment_registration/gift/index.vue'
import GiftHistories from '@/pages/mypage/payment_histories/gift/index.vue'
import TotalTransfers from '@/pages/mypage/payment_histories/total_transfer/index.vue'
import CoinHistories from '@/pages/mypage/coin_histories/index.vue'
import CoinPurchasePending from '@/pages/mypage/coin_purchase/pending.vue'
import CoinPurchase from '@/pages/mypage/coin_purchase/index.vue'
import CoinPurchaseComplete from '@/pages/mypage/coin_purchase/complete.vue'
import CoinPurchaseCheck from '@/pages/mypage/coin_purchase/check.vue'
import GachaOdds from '@/pages/gacha_odds/index.vue'
import FurnitureGachaOdds from '@/pages/furniture_gacha_odds/index.vue'
import GamePeriodRanking from '@/pages/game_period_ranking/index.vue'
import GamesRanking from '@/pages/games/ranking/index.vue'
import NoticePage from '@/pages/notice/page/index.vue'
import AgeVerification from '@/pages/age_verification/index.vue'
import AgeVerificationCompleteFailure from '@/pages/age_verification/complete/failure.vue'
import NoticePenalty from '@/pages/notice/penalty/index.vue'
import MyPageMusicRights from '@/pages/mypage/music_rights/index.vue'
import GeneralRanking from '@/pages/ranking/general/list/index.vue'
import QrcodePage from '@/pages/notice/qrcode/index.vue'
import RealityMemories2024 from '@/pages/campaign/reality_memories_2024/index.vue'
import Invitation from '@/pages/invitation/index.vue'
import Maintenance from '@/pages/maintenance/index.vue'
import Wise from '@/pages/mypage/payment_registration/wise/index.vue'
import WisePayout from '@/pages/mypage/payment_registration/wise/payout.vue'
import WiseSuccess from '@/pages/mypage/payment_registration/wise/success.vue'
import WiseHistory from '@/pages/mypage/payment_registration/wise/history.vue'
import ObsStream from '@/pages/mypage/obs_stream/index.vue'
import Live2dModelUpload from '@/pages/mypage/live2d_model_upload/index.vue'
import ChargeGradePrizeDetail from '@/pages/charge_grade/prize_detail/index.vue'
import MarketShop from '@/pages/market/shop/index.vue'
import MarketShareShop from '@/pages/market/share/shop/index.vue'
import FeedCamera from '@/pages/feed_camera/index.vue'
import FreshLiverRanking from '@/pages/fresh_liver_ranking/index.vue'
import ChargeGradeVipPointHistory from '@/pages/charge_grade/vip_point_history/index.vue'
import VipPointShop from '@/pages/mypage/vip_point_shop/index.vue'
import VipPointShopComplete from '@/pages/mypage/vip_point_shop/complete.vue'
import ChargeGradeContinuationStatus from '@/pages/charge_grade/continuation_status/index.vue'
import AgencyEventRanking from '@/pages/agency_event_ranking/index.vue'

import store from '../store'
import { sendAccessLog } from '@/utils/AccessLog'
import { checkMaintenance } from '@/utils/MaintenanceCheck'
import { attachQueryParamsIfNeeded } from './attach_query_params'
import Comments from '@/pages/comments/index.vue'
import HistoryAlbum20M from '@/pages/campaign/reality_histories_20m/index.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/events/:eventId',
      name: 'events',
      component: Event,
    },
    {
      path: '/gacha_odds/:gachaId',
      name: 'gacha_odds',
      component: GachaOdds,
    },
    {
      path: '/furniture_gacha_odds/:furnitureGachaId',
      name: 'furniture_gacha_odds',
      component: FurnitureGachaOdds,
    },
    {
      path: '/ranking/:vliveId',
      name: 'ranking',
      component: Ranking,
    },
    {
      path: '/download',
      name: 'download',
      component: Download,
      meta: { skipMaintenanceCheck: true },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { skipMaintenanceCheck: true },
    },
    {
      path: '/login/success',
      name: 'login_success',
      component: LoginSuccess,
      meta: { skipMaintenanceCheck: true },
    },
    {
      path: '/login/error',
      name: 'login_error',
      component: LoginError,
      meta: { skipMaintenanceCheck: true },
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
      meta: { skipMaintenanceCheck: true },
    },
    {
      path: '/mypage/',
      name: 'mypage',
      component: MyPage,
      beforeEnter: (_to, _from, next) => {
        const ua = navigator.userAgent
        const isIosSafari = ua.match(/Version\/([0-9._]+).*Mobile.*Safari.*/)
        if (isIosSafari) {
          const performanceEntries = performance.getEntriesByType(
            'navigation'
          )[0] as PerformanceNavigationTiming

          if (performanceEntries.type === 'back_forward') {
            // キャッシュから読み込まれた場合にリロード
            location.reload()
          }
        }
        next()
      },
    },
    {
      path: '/mypage/payment_registration/',
      name: 'payment_registration',
      component: PaymentRegistration,
    },
    {
      path: '/mypage/payment_registration/personal',
      name: 'personal',
      component: Personal,
    },
    {
      path: '/mypage/payment_registration/bank',
      name: 'bank',
      component: Bank,
    },
    {
      path: '/mypage/payment_registration/wise/',
      name: 'wise',
      component: Wise,
    },
    {
      path: '/mypage/payment_registration/wise/payout',
      name: 'wise_payout',
      component: WisePayout,
    },
    {
      path: '/mypage/payment_registration/wise/payout/success',
      name: 'wise_success',
      component: WiseSuccess,
    },
    {
      path: '/mypage/payment_registration/wise/history',
      name: 'wise_history',
      component: WiseHistory,
    },
    {
      path: '/mypage/payment_histories',
      name: 'payment_histories',
      component: PaymentHistories,
    },
    {
      path: '/mypage/payment_registration/gift',
      name: 'gift',
      component: Gift,
    },
    {
      path: '/mypage/payment_histories/gift',
      name: 'gift_histories',
      component: GiftHistories,
    },
    {
      path: '/mypage/payment_histories/total_transfer',
      name: 'total_transfers',
      component: TotalTransfers,
    },
    {
      path: '/mypage/coin_histories',
      name: 'coin_histories',
      component: CoinHistories,
    },
    {
      path: '/mypage/coin_purchase',
      name: 'coin_purchase',
      component: CoinPurchase,
    },
    {
      path: '/mypage/coin_purchase/pending/:purchaseId',
      name: 'coin_purchase_pending',
      component: CoinPurchasePending,
      meta: { skipMaintenanceCheck: true }, // 注文完了ページはメンテ見ない
    },
    {
      path: '/mypage/coin_purchase/complete',
      name: 'coin_purchase_complete',
      component: CoinPurchaseComplete,
      meta: { skipMaintenanceCheck: true }, // 処理完了ページはメンテ見ない
    },
    {
      path: '/mypage/coin_purchase/check',
      name: 'coin_purchase_check',
      component: CoinPurchaseCheck,
      meta: { skipMaintenanceCheck: true }, // 決済確認ページはメンテ見ない
    },
    {
      path: '/mypage/obs_stream',
      name: 'obs_stream',
      component: ObsStream,
    },
    {
      path: '/mypage/live2d_model_upload',
      name: 'live2d_model_upload',
      component: Live2dModelUpload,
    },
    {
      path: '/charge_grade/prize_detail/check_version/:thresholdSettingId',
      name: 'charge_grade_prize_detail_check_version',
      component: ChargeGradePrizeDetail,
      meta: { checkVersion: true },
    },
    {
      path: '/charge_grade/prize_detail/:thresholdSettingId',
      name: 'charge_grade_prize_detail',
      component: ChargeGradePrizeDetail,
      meta: { checkVersion: false },
    },
    {
      path: '/mypage/music_rights',
      name: 'mypage_music_rights',
      component: MyPageMusicRights,
    },
    {
      path: '/game_ranking/:periodId',
      name: 'game_ranking',
      component: GamePeriodRanking,
    },
    {
      path: '/games/:periodId/ranking',
      name: 'games_ranking',
      component: GamesRanking,
    },
    {
      path: '/notice/page/:id',
      name: 'notice_page',
      component: NoticePage,
      props: true,
      meta: { skipMaintenanceCheck: true },
    },
    {
      path: '/age_verification/complete/failure',
      name: 'age_verification_complete_failure',
      component: AgeVerificationCompleteFailure,
      meta: { skipMaintenanceCheck: true },
    },
    {
      path: '/age_verification/:ageCategory',
      name: 'notice_age_verification',
      component: AgeVerification,
      props: true,
      meta: { skipMaintenanceCheck: true },
    },
    {
      path: '/notice/penalty/:id(\\d+)',
      name: 'notice_penalty',
      component: NoticePenalty,
    },
    {
      path: '/music_rights',
      name: 'music_rights',
      redirect: { name: 'mypage_music_rights' },
    },
    {
      path: '/campaign/cluster',
      name: 'campaign_cluster',
      component: Download,
    },
    {
      path: '/ranking/general/list',
      name: 'general_ranking',
      component: GeneralRanking,
    },
    {
      path: '/notice/qrcode/:code',
      name: 'qrcode_page',
      component: QrcodePage,
      props: true,
    },
    {
      path: '/notice/reality_memories_2024/:vliveId?',
      name: 'campaign_reality_memories_2024',
      component: RealityMemories2024,
    },
    {
      path: '/notice/reality_histories_20m/:vliveId?',
      name: 'campaign_reality_histories_20m',
      component: HistoryAlbum20M,
    },
    {
      path: '*',
      name: 'notfound',
      component: NotFound,
      meta: { skipMaintenanceCheck: true },
    },
    {
      path: '/invitations/:profileId',
      name: 'invitation',
      component: Invitation,
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: Maintenance,
      meta: { skipMaintenanceCheck: true },
    },
    {
      path: '/comments/:mediaIdAndHash',
      name: 'comments',
      component: Comments,
    },
    {
      path: '/market/shop/:vliveId',
      name: 'market_shop',
      component: MarketShop,
    },
    {
      path: '/market/share/shop/:profileId',
      name: 'market_share_shop',
      component: MarketShareShop,
    },
    {
      path: '/feed_camera',
      name: 'feed_camera',
      component: FeedCamera,
    },
    {
      path: '/fresh_liver_ranking',
      name: 'fresh_liver_ranking',
      component: FreshLiverRanking,
    },
    {
      path: '/charge_grade/vip_point_history',
      name: 'charge_grade_vip_point_history',
      component: ChargeGradeVipPointHistory,
    },
    {
      path: '/charge_grade/continuation_status',
      name: 'charge_grade_continuation_status',
      component: ChargeGradeContinuationStatus,
    },
    {
      path: '/mypage/vip_point_shop',
      name: 'vip_point_shop',
      component: VipPointShop,
    },
    {
      path: '/mypage/vip_point_shop/complete',
      name: 'vip_point_shop_complete',
      component: VipPointShopComplete,
      meta: { skipMaintenanceCheck: true }, // 処理完了ページはメンテ見ない
    },
    {
      path: '/agency_event_ranking/:eventKey',
      name: 'agency_event_ranking',
      component: AgencyEventRanking,
      meta: { skipLoggingAccessGetVliveId: true },
    },
  ],
})

declare let gtag: any

router.beforeEach(async (to, from, next) => {
  let referrer = document.referrer
  if (from.matched.length > 0) {
    // 同一サイト内遷移
    referrer = window.location.origin + from.fullPath
  }
  store.commit('referrer', referrer)

  // メンテナンスチェック（skipMaintenanceCheckが設定されてないページのみチェック）
  if (!to.matched.some((record) => record.meta.skipMaintenanceCheck)) {
    // メンテナンス状態の取得
    const isMaintenance = await checkMaintenance()
    if (isMaintenance && to.name !== 'maintenance') {
      // メンテナンス画面へリダイレクトさせるタイミングが初回かどうか
      if (!sessionStorage.getItem('isMaintenanceReloaded')) {
        // ローカルストレージからキーの存在をチェック
        if (localStorage.getItem('targetPathPreMaintenance') != null) {
          // キーが存在する場合、削除する
          localStorage.removeItem('targetPathPreMaintenance')
        }

        // 遷移しようとしていたページのパスをローカルストレージに保存
        // （メンテナンス終了時、リロードしたタイミングでこのパスへ遷移させる）
        localStorage.setItem('targetPathPreMaintenance', to.fullPath)

        // 初回遷移かどうかの判定フラグをセット
        sessionStorage.setItem('isMaintenanceReloaded', 'true')
      }

      next({ name: 'maintenance' })
      return
    }
  }

  // 一部のquery paramsを遷移先routeへ引き継ぐ
  const queryParamsToBeInherited = new Set([
    'utm_source', // Google AnalyticsのカスタムURLによる流入元計測用（明示的に引き継がないとvue-routerによる遷移の結果追跡できなくなってしまう）
    'utm_medium', // 同上
    'utm_campaign', // 同上
  ])

  const attachedRoute = attachQueryParamsIfNeeded(
    to,
    from,
    queryParamsToBeInherited
  )

  if (attachedRoute) {
    next(attachedRoute)
    return
  }

  next()
})

router.afterEach((to) => {
  gtag('config', 'UA-136508263-1', { page_path: to.path })

  // skipLoggingAccessGetVliveIdがtrueの場合はgetVliveId()をスキップする
  const shouldSkipGetVliveId = to.matched.some(
    (record) => record.meta.skipLoggingAccessGetVliveId
  )
  sendAccessLog(to, shouldSkipGetVliveId)
})

export default router
